import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import Select from "@material-ui/core/Select";
import withModal from "../withModal";
import FlowFieldsUsed from "../../flows/FlowFieldsUsed";
import { hideModal } from "../../../actions/actionCreators";
import MaterialModal from "../MaterialModal";
import MenuItem from "@material-ui/core/MenuItem";
import BouncingDots from "../../loading/BouncingDots";

const FlowFieldsUsedModal = ({ modalProps, isOpen }) => {
    const dispatch = useDispatch();

    const [reportExtension, setReportExtension] = useState(2);

    const reportExtensions = [
        {
            value: "1",
            label: ".txt",
        },
        {
            value: "2",
            label: ".xlsx",
        },
    ];

    const activeCountQueue = useSelector(state => state.countLog.activeList);
    const historicalCountQueue = useSelector(state => state.countLog.historicalList);

    const { workflowId, listType } = modalProps;

    let countItem;
    if (Object.entries(modalProps).length != 0) {
        if (listType == "Active") {
            countItem = activeCountQueue.find(x => x.WorkflowId == workflowId);
        } else {
            countItem = historicalCountQueue.find(x => x.WorkflowId == workflowId);
        }
    }

    const hide = () => dispatch(hideModal("FLOW_FIELDS_USED"));

    const handleChange = e => setReportExtension(e.target.value);

    const downloadFieldReport = () => {
        const flowItemId = countItem.FlowItemId;
        const companyId = countItem.RequesteeCompanyId;
        window.location = `/TableReport/ExportCountApprovalFields?flowItemId=${flowItemId}&companyId=${companyId}&ext=${reportExtension}`;
        hide();
    };

    let content;
    if (!workflowId) {
        content = (
            <div>
                <strong>Data unavailable</strong>
            </div>
        );
    } else if (countItem) {
        content = (
            <React.Fragment>
                <FlowFieldsUsed
                    workflowId={workflowId}
                    companyId={countItem.RequesteeCompanyId}
                    flowItemId={countItem.FlowItemId}
                />
                <br />
                <div className="row col-sm" style={{ display: "flex", flexFlow: "row", flex: "1" }}>
                    <div className="form-group" style={{ width: "200px", marginLeft: "20px", marginRight: "0" }}>
                        <label className="control-label" htmlFor="">
                            File Type
                        </label>
                        <br />
                        <Select
                            id="field-used-select"
                            onChange={handleChange}
                            value={reportExtension}
                            style={{ fontSize: 15, width: 100 }}
                        >
                            {reportExtensions.map((field, i) => (
                                <MenuItem key={i} value={field.value}>
                                    {field.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                </div>
            </React.Fragment>
        );
    } else {
        content = (
            <div style={{ margin: "30px 0px 30px 415px" }}>
                <BouncingDots />
            </div>
        );
    }

    return (
        <MaterialModal
            title="Fields Used"
            isOpen={isOpen}
            onClose={hide}
            id="fields-used"
            maxWidth="lg"
            showPrimaryButton={true}
            primaryButtonText="Download"
            onPrimaryButtonRequest={downloadFieldReport}
            isPrimaryButtonDisabled={!countItem}
        >
            {content}
        </MaterialModal>
    );
};

FlowFieldsUsedModal.propTypes = {
    modalProps: PropTypes.object,
    isOpen: PropTypes.bool,
    hideModal: PropTypes.func,
    activeCountQueue: PropTypes.array,
    historicalCountQueue: PropTypes.array,
};

export default withModal(FlowFieldsUsedModal, "FLOW_FIELDS_USED");
